/* PDP quantity limit — when a customer enters more than the available online stock,
   clamp the quantity to what's available and show an editable "Need more?" message
   that links to the quote page. Config is read from data-* attributes on .atc-wrapper, and
   on any other element tagged data-qty-limit-scope (the sticky add-to-cart bar). */
(function () {
  function init(wrap) {
    if (wrap.__qtyLimit) return;
    wrap.__qtyLimit = true;

    var max = parseInt(wrap.getAttribute('data-qty-max'), 10);
    if (!max || max < 1) return; // unlimited (not tracked / continue-selling on)

    var url = (wrap.getAttribute('data-qty-url') || '').trim();
    var tpl = wrap.getAttribute('data-qty-msg') || 'Only [qty] items available online.';
    var linkText = wrap.getAttribute('data-qty-link') || 'Need more?';
    var msg = null;
    var clamping = false;

    function ensureMsg() {
      if (msg && msg.isConnected) return msg;
      msg = wrap.querySelector('.pdp-qty-limit-msg');
      if (!msg) {
        msg = document.createElement('div');
        msg.className = 'pdp-qty-limit-msg';
        msg.hidden = true;
        var row = wrap.querySelector('.pdp-qty-currency-row') || wrap.querySelector('.product-form--atc-qty');
        if (row && row.parentNode) row.parentNode.insertBefore(msg, row.nextSibling);
        else wrap.appendChild(msg);
      }
      return msg;
    }
    function show() {
      var m = ensureMsg();
      var text = String(tpl).replace('[qty]', max);
      // No destination set, so state the limit without linking anywhere.
      m.innerHTML = url
        ? text + ' <a class="pdp-qty-limit-link" href="' + url + '">' + linkText + '</a>'
        : text;
      m.hidden = false;
    }
    function hide() { if (msg) msg.hidden = true; }

    function clampField(f) {
      if (clamping) return;
      var v = parseInt(f.value, 10);
      if (isNaN(v)) return;
      if (v > max) {
        f.value = max;
        var cdd = f.closest && f.closest('.pdp-cdd');
        if (cdd) { var disp = cdd.querySelector('.pdp-cdd-display'); if (disp) disp.textContent = max; }
        show();
        clamping = true;
        f.dispatchEvent(new Event('change', { bubbles: true }));
        clamping = false;
      } else {
        hide();
      }
    }

    ['input', 'change'].forEach(function (ev) {
      wrap.addEventListener(ev, function (e) {
        var t = e.target;
        if (!t) return;
        if (t.name === 'quantity' ||
            (t.hasAttribute && (t.hasAttribute('data-quantity-input') || t.hasAttribute('data-quantity-select')))) {
          clampField(t);
        }
      }, true);
    });
  }

  function boot() {
    var wraps = document.querySelectorAll('.atc-wrapper[data-qty-max], [data-qty-limit-scope][data-qty-max]');
    for (var i = 0; i < wraps.length; i++) init(wraps[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
